export default {"src":"/_next/static/media/photo.c282d170.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};